// extracted by mini-css-extract-plugin
export default {"label":"style_label__GDNmR","labelUp":"style_labelUp__PJB-n","normalText":"style_normalText__stnLz","errorText":"style_errorText__GwpcP"};